import { MILLISECONDS_PER_DAY } from "@/constants/time.constants";

export const DAY_IN_MILLISECONDS = MILLISECONDS_PER_DAY;
export const DAYS_IN_WEEK = 7;
